module.exports = __webpack_public_path__ + "img/product-placeholder-11.1743d98.png";